import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { HEMP,STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function getApprovalsAPI(filters) {
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/store/products/approvals/details?${getQueryString(filters)}`)
}

export async function updateApprovalAPI(data){
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/store/products/approvals/update`, data)
}

export async function getApprovalHistoryAPI(){
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/admin/store/products/approvals/history/details')
}

export async function getApprovalDetailAPI(approvalId){
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/store/products/approvals/${approvalId}`)
}

export async function overrideApprovalAPI(approvalId, filters, data){
    return await  (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/store/products/override/${approvalId}?${getQueryString(filters)}`, data)
}